export const truncate = (input: string, length = 90, addDots = true) =>
  input.length > length
    ? `${input.substring(0, length)}${addDots ? '...' : ''}`
    : input;
